import axios from 'axios'

const endpoint = '/api/system'

export default {
  get: () => axios.get(endpoint),
}
